<template>
  <div class="content">
    <div class="rotation">
      <div class="rotation_content">
        <div class="detail_content">
          <div class="test_title">
            {{inforList.paper_name}}
          </div>
          <div class="test_tips">
            有<em></em>标记的为正确答案，如果所选答案和正确答案相同则不显示。只有问答题才需要打分，其他题目已自动计算。
          </div>
          <ul class="basce_infor">
            <li>
              <span>类型：</span>
              <p v-if="inforList.category === 1">创业计划(SYB)</p>
              <p v-else>创业认知(GYB)</p>
            </li>
            <li>
              <span>姓名：</span>
              <p>{{inforList.student_name}}</p>
            </li>
            <li>
              <span>身份证：</span>
              <p>{{inforList.idcard}}</p>
            </li>
            <li>
              <span>分数：</span>
              <p v-show="inforList.score != 0">{{inforList.score}}</p>
            </li>
          </ul>
          <ul class="answer_ul">
            <li v-for="(item,index) in detailList" :key="index">
              <p v-if="item.type != 4">{{item.name}}</p>
              <div class="answer" v-if="item.type === 1 || item.type === 2">
                <el-radio v-model="item.option_id" disabled 
                  :class="{nopass_nopass:(items.is_checked === 0 && items.is_true === 1)}"
                  v-for="items in item.option_list"
                  :key="items.option_id"
                  :label="items.option_id"
                  :value="items.option_id">
                    {{items.value}}
                </el-radio>
              </div>
              <div class="answer" v-if="item.type === 3 ">
                <el-checkbox disabled 
                :class="{nopass_nopass:(items.is_checked === 0 && items.is_true === 1)}"
                v-for="items in item.option_list"
                :key="items.option_id"
                :label="items.option_id"
                :checked="items.checked"
                :value="items.option_id">
                  {{items.value}}
                </el-checkbox>
              </div>
            </li>
            <li v-for="(item,index) in answerList" :key="item.question_id">
              <p v-if="item.type === 4">{{item.name}}</p>
              <div class="answer" v-if="item.type === 4">
                <div class="answer_checkbox">
                  <el-input type="textarea" v-model="item.reference_answer" disabled ></el-input>
                </div>
                <div class="answer_score">
                  <span>分数：</span>
                  <el-input type="number" v-model="formList[index].score" min="0" :max="answerScore" @change="changeScore(index,formList[index].score)"></el-input> 
                </div>
              </div>
              <div class="reference_answer">
                <span>参考答案：</span>
                <p>{{item.reference_answer}}</p>
              </div>
            </li>
          </ul>
          <div class="marking_papers_btn">
            <div class="comment_input">
              <span>评语：</span>
              <el-input type="textarea" v-model="comment" :rows="4"></el-input>
            </div>
           
            <el-button type="success" @click="markingPapers">批卷</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default{
    name:'ideaAnalysisDetail',
    components:{
    },
    data(){
      return {
        detailList:{},
        inforList:{},
        questionList:[],
        answerList:[],
        formList:[],
        comment:'',
        answerScore:''
      }
    },
    created(){
      this.id = this.$route.params && this.$route.params.id
      let params = {
        id:this.id,
      }
      this.getinfor(params)
    },
    mounted(){
      
    },
    methods:{
      getinfor(params){
        this.$api.user.studentExamDetail(params)
          .then(res=>{
            if(res.code === 0){
              this.inforList = res.result
              let settingArr = this.inforList.setting
              let arr = this.inforList.question_list
              let that = this
              settingArr.forEach(function(v,k){
                if(v.type === 4){
                  that.answerScore = v.score
                }
              })
              arr.forEach(function(v,k){
                if(v.option_list){
                  v.option_list.forEach(function(m,n){
                    m.checked = false
                    if(m.is_checked === 1){
                      v.option_id = m.option_id
                      m.checked = true
                    }
                  })
                }
                if(v.type === 4){
                  v.score = 0
                  that.answerList.push(v)
                  that.formList.push({question_id:v.question_id,score:0})
                }
              })
              this.detailList = arr
            }
          }) 
      },
      markingPapers(){
        let params ={
          id:this.id,
          comment:this.comment,
          essay_score:JSON.stringify(this.formList)
        }
         this.$api.user.studentExamCheck(params)
          .then(res=>{
            if(res.code === 0){
              this.$message.success('批改完毕')
              this.$router.replace({
                path:'/student/test'
              })
            }
          })
      },
      changeScore(index,val){
        if(Number(val) > this.answerScore){
          this.formList[index].score = this.answerScore
        }
      },
    },
    watch:{
    }
  }
</script>
<style scoped lang="scss">
  @import '../../assets/scss/content.scss';
  @import '../../assets/scss/testDetail.scss';
</style>